/**
 * Workspace state, encoded in the URL.
 *
 * Putting it in the query string makes a chart shareable and bookmarkable —
 * paste the link and the other person opens the same symbol, interval and
 * theme.
 */

export const INTERVALS = [
  { value: "1", label: "1m" },
  { value: "5", label: "5m" },
  { value: "15", label: "15m" },
  { value: "60", label: "1H" },
  { value: "240", label: "4H" },
  { value: "D", label: "1D" },
  { value: "W", label: "1W" },
  { value: "M", label: "1M" },
];

export const DEFAULT_WORKSPACE = {
  symbols: ["NASDAQ:AAPL", "NASDAQ:MSFT", "COINBASE:BTCUSD", "AMEX:SPY"],
  interval: "D",
  theme: "dark",
};

const VALID_INTERVALS = INTERVALS.map((i) => i.value);

export const readWorkspace = () => {
  if (typeof window === "undefined") return DEFAULT_WORKSPACE;

  const params = new URLSearchParams(window.location.search);

  const symbols = (params.get("s") || "")
    .split(",")
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);

  const interval = params.get("i");
  const theme = params.get("t");

  return {
    // The chart reads slot 0; the rest are kept as the default watchlist seed.
    symbols:
      symbols.length > 0
        ? [...symbols, ...DEFAULT_WORKSPACE.symbols].slice(0, 4)
        : DEFAULT_WORKSPACE.symbols,
    interval: VALID_INTERVALS.includes(interval)
      ? interval
      : DEFAULT_WORKSPACE.interval,
    theme: theme === "light" || theme === "dark" ? theme : DEFAULT_WORKSPACE.theme,
  };
};

/**
 * Mirrors state into the address bar. `replaceState` rather than a push, so
 * changing symbol doesn't stack up history entries the Back button has to
 * chew through.
 */
export const writeWorkspace = (workspace) => {
  if (typeof window === "undefined") return;

  const params = new URLSearchParams();
  params.set("s", workspace.symbols[0]);
  params.set("i", workspace.interval);
  params.set("t", workspace.theme);

  window.history.replaceState(
    null,
    "",
    `${window.location.pathname}?${params.toString()}`,
  );
};
